module.exports = __webpack_public_path__ + "media/components/assets/img/bg/noise-2-e098b1844c3cf024430579e72b08869d.svg";